/**
 * 契約編集のステップ
 */
export const CONTRACT_EDIT_STEP = {
  INPUT: 'input',
  CONFIRMATION: 'confirmation',
  DELETE: 'delete',
} as const;

/**
 * 契約編集のステップのコード値
 */
export type ContractEditStep =
  typeof CONTRACT_EDIT_STEP[keyof typeof CONTRACT_EDIT_STEP];
